// @flow

import * as React from 'react';

type Props = {
  children?: React.Node,
  className?: string,
  selected?: boolean,
  onClick?: Function,
  id: string,
}

class MenuItem extends React.PureComponent<Props> {
  static defaultProps = {
    className: '',
    selected: false,
    onClick: (): void => {},
    children: null,
  };

  render() {
    return (
      <button
        className={`${this.props.selected === this.props.id ? 'active-item' : ''} ${this.props.className || ''}`}
        onClick={this.props.onClick}
      >
        {this.props.children}
      </button>
    );
  }
}

export default MenuItem;
